import { memo, useMemo } from 'react';

import { handleHeaderItemClick } from '../utils';

import DropdownItem from './DropdownItem';

import Image from '@shared/Image';
import type { MenuItem } from '@shared-types/menu.types';
import { imgBaseUrl } from '@utilities/WindowContext';
const FeaturedItem = ({ item }: { item: MenuItem }) => {
  const handleClick = useMemo(() => handleHeaderItemClick(item), [item]);

  if (item.customProperties?.dropdown) {
    return <DropdownItem item={item} />;
  }

  return (
    <a
      href={item.href}
      target={item.target}
      onClick={handleClick}
      onAuxClick={handleClick}
      className='pk-d--flex pk-text--text-01'
    >
      {item.icon ? <Image src={`${imgBaseUrl}/imgml/${item.icon}`} alt={item.text} /> : item.text}
    </a>
  );
};

export default memo(FeaturedItem);
